import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import Loader from '../Loader/Loader'

const hiddenInputStyle = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  padding: '0',
  border: '0',
  clip: 'rect(0, 0, 0, 0)',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
};

export default function UploadButton({ 
  onFileUpload, 
  label = "Upload", 
  sx, 
  loading , 
  allowMultiple=false , 
  acceptableFile=".pdf" , 
  variant="outlined" ,
  color="primary",
  disabled

}) {
  const [dragging, setDragging] = React.useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    if (!dragging) {
      setDragging(true); // Show that a file is being dragged over
    }
  };

  const handleDragLeave = () => {
    setDragging(false); // Hide drag indicator when file leaves the area
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const files = e.dataTransfer.files;
    if (files.length) {
      handleFileUpload({ target: { files } }); // Trigger file upload handler
    }
  };

  const handleFileUpload = async (event) => {
    if(allowMultiple){
      onFileUpload(event.target.files)
    }else{
      onFileUpload(event.target.files[0])
    }
    event.target.value = ''; 
  };

  return (
    <>
      {
        loading ?
          <Button
            role={undefined}
            variant={variant}
            sx={sx}
            disable={true}
            color={color}
          >
            <Loader />
          </Button>
          :
          <>
            <Button
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              component="label"
              role={undefined}
              variant={variant}
              startIcon={<CloudUploadOutlinedIcon />}
              sx={sx}
              size="large"
              color={color}
              disabled={disabled}
            >
              {label}
              <input
                type="file"
                onChange={handleFileUpload}
                accept={acceptableFile}
                // style={{ display: 'none' }} // Use style to hide the input
                style={hiddenInputStyle} // Use visually hidden style
                multiple={allowMultiple}
                
              />
            </Button>
          </>
      }
    </>
  );
}